/**
 * Bootstrap 4 Inits + Handlers
 *
 * @author John Ranby
 * @see    https://github.com/jranby
 */
jQuery(document).ready(function($) {


    $('input[type=radio][name=enquiry_type]').change(function(evt) {
        $('.form-wrapper').removeClass('d-none');
    });

    // ---------------------------------------------------------------------

    /*
     * @TODO
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    $('.close-modal').on('click', function(e) {
        e.preventDefault();
        $(this).parent().find('.form-messages').removeClass('success error').addClass('d-none').text('');
    });

    $('.modal').on('hidden.bs.modal', function() {
        $(this).find('.form-messages').removeClass('success error').addClass('d-none').text('');
    });

    // ---------------------------------------------------------------------

    /*
     * @TODO
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    $('a[data-imagelightbox="gallery"]').imageLightbox({
        activity: true,
        overlay: true,
        arrows: true,
        button: true,
        caption: true,
        fullscreen: true,
        gutter: 20,
        navigation: false,
        preloadNext: true
    });

    // ---------------------------------------------------------------------

    /*
     * @TODO
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    $('.additional-image').on('click', function(e) {
        e.preventDefault();
        
        var additional_src = $(this).find('img').attr('src'),
            featured_src   = $('#product-featured').find('img').attr('src');

        $('#product-featured').find('img').attr('src', additional_src);
        $(this).find('img').attr('src', featured_src);
    });

    // ---------------------------------------------------------------------

    /*
     * @TODO
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    $('.filter-term').on('click', function(e) {
        e.preventDefault();
        
        var product_cat   = $(this).data('filter'),
            gallery_items = $('.filtered-gallery').find('.gallery-item-wrap'),
            masnryElement = document.getElementById('gallery-block'),
            msnry         = Masonry.data(masnryElement);

        $('.filter-term').removeClass('active');
        $(this).addClass('active');

        gallery_items.removeClass('d-none');
        gallery_items.not('.' + product_cat).addClass('d-none');
        msnry.layout();
    });
});

$(window).on('load', function() {

    var elem = document.querySelector('.products');
    var msnry = new Masonry( elem, {
      // options
      itemSelector: '.product',
      columnWidth: '.product',
      percentPosition: true
    });
    
    var $grid = $('#gallery-block').imagesLoaded(function() {
        $grid.masonry({
          itemSelector: '.gallery-item-wrap',
          columnWidth: '.gallery-item-wrap:not(.d-none)',
          percentPosition: true
        });
    });
});
